import type { BoggleResolvedChallengeConfig } from '~/boggle/config/challenges/modTypes'

function collectResolvedChallengeModifiers(
  resolvedChallenge: BoggleResolvedChallengeConfig | null,
) {
  if (!resolvedChallenge) {
    return []
  }

  return resolvedChallenge.boardDistribution
    ? [resolvedChallenge.boardDistribution, ...resolvedChallenge.bonuses]
    : [...resolvedChallenge.bonuses]
}

export function getBoggleResolvedMaxWordLength(
  resolvedChallenge: BoggleResolvedChallengeConfig | null,
) {
  for (const mod of collectResolvedChallengeModifiers(resolvedChallenge)) {
    for (const outcome of mod.outcomes) {
      if (outcome.kind === 'max-word-length') {
        return outcome.maxWordLength
      }
    }
  }

  return null
}

export function getBoggleResolvedRequiredLetter(
  resolvedChallenge: BoggleResolvedChallengeConfig | null,
) {
  for (const mod of collectResolvedChallengeModifiers(resolvedChallenge)) {
    for (const outcome of mod.outcomes) {
      if (outcome.kind === 'required-letter') {
        return outcome.letter
      }
    }
  }

  return null
}
